/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { registryControllerAddLogo } from '../fn/registry/registry-controller-add-logo';
import { RegistryControllerAddLogo$Params } from '../fn/registry/registry-controller-add-logo';
import { registryControllerAddUsers } from '../fn/registry/registry-controller-add-users';
import { RegistryControllerAddUsers$Params } from '../fn/registry/registry-controller-add-users';
import { registryControllerAssignRegistry } from '../fn/registry/registry-controller-assign-registry';
import { RegistryControllerAssignRegistry$Params } from '../fn/registry/registry-controller-assign-registry';
import { registryControllerCreate } from '../fn/registry/registry-controller-create';
import { RegistryControllerCreate$Params } from '../fn/registry/registry-controller-create';
import { registryControllerCreateRegistryEndCustomer } from '../fn/registry/registry-controller-create-registry-end-customer';
import { RegistryControllerCreateRegistryEndCustomer$Params } from '../fn/registry/registry-controller-create-registry-end-customer';
import { registryControllerDelete } from '../fn/registry/registry-controller-delete';
import { RegistryControllerDelete$Params } from '../fn/registry/registry-controller-delete';
import { registryControllerDissociaUser } from '../fn/registry/registry-controller-dissocia-user';
import { RegistryControllerDissociaUser$Params } from '../fn/registry/registry-controller-dissocia-user';
import { registryControllerForceDelete } from '../fn/registry/registry-controller-force-delete';
import { RegistryControllerForceDelete$Params } from '../fn/registry/registry-controller-force-delete';
import { registryControllerGetAll } from '../fn/registry/registry-controller-get-all';
import { RegistryControllerGetAll$Params } from '../fn/registry/registry-controller-get-all';
import { registryControllerGetAllDeleted } from '../fn/registry/registry-controller-get-all-deleted';
import { RegistryControllerGetAllDeleted$Params } from '../fn/registry/registry-controller-get-all-deleted';
import { registryControllerGetOne } from '../fn/registry/registry-controller-get-one';
import { RegistryControllerGetOne$Params } from '../fn/registry/registry-controller-get-one';
import { registryControllerGetTypes } from '../fn/registry/registry-controller-get-types';
import { RegistryControllerGetTypes$Params } from '../fn/registry/registry-controller-get-types';
import { registryControllerRemoveLogo } from '../fn/registry/registry-controller-remove-logo';
import { RegistryControllerRemoveLogo$Params } from '../fn/registry/registry-controller-remove-logo';
import { registryControllerRestore } from '../fn/registry/registry-controller-restore';
import { RegistryControllerRestore$Params } from '../fn/registry/registry-controller-restore';
import { registryControllerUpdate } from '../fn/registry/registry-controller-update';
import { RegistryControllerUpdate$Params } from '../fn/registry/registry-controller-update';
import { registryControllerUpdateRegistryEndCustomer } from '../fn/registry/registry-controller-update-registry-end-customer';
import { RegistryControllerUpdateRegistryEndCustomer$Params } from '../fn/registry/registry-controller-update-registry-end-customer';
import { RegistryItem } from '../models/registry-item';
import { RegistryResponse } from '../models/registry-response';
import { RegistryTypeResponse } from '../models/registry-type-response';

@Injectable({ providedIn: 'root' })
export class RegistryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `registryControllerGetAll()` */
  static readonly RegistryControllerGetAllPath = '/registry';

  /**
   * Restituisce l'elenco delle aziende.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registryControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  registryControllerGetAll$Response(params: RegistryControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryResponse;
}>> {
    return registryControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco delle aziende.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registryControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  registryControllerGetAll(params: RegistryControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryResponse;
}> {
    return this.registryControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryResponse;
}>): BaseResponse & {
'data'?: RegistryResponse;
} => r.body)
    );
  }

  /** Path part for operation `registryControllerCreate()` */
  static readonly RegistryControllerCreatePath = '/registry';

  /**
   * Crea una azienda.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registryControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registryControllerCreate$Response(params: RegistryControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>> {
    return registryControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea una azienda.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registryControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registryControllerCreate(params: RegistryControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryItem;
}> {
    return this.registryControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>): BaseResponse & {
'data'?: RegistryItem;
} => r.body)
    );
  }

  /** Path part for operation `registryControllerCreateRegistryEndCustomer()` */
  static readonly RegistryControllerCreateRegistryEndCustomerPath = '/registry/registry_end_customer';

  /**
   * Crea una azienda cliente finale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registryControllerCreateRegistryEndCustomer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registryControllerCreateRegistryEndCustomer$Response(params: RegistryControllerCreateRegistryEndCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>> {
    return registryControllerCreateRegistryEndCustomer(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea una azienda cliente finale.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registryControllerCreateRegistryEndCustomer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registryControllerCreateRegistryEndCustomer(params: RegistryControllerCreateRegistryEndCustomer$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryItem;
}> {
    return this.registryControllerCreateRegistryEndCustomer$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>): BaseResponse & {
'data'?: RegistryItem;
} => r.body)
    );
  }

  /** Path part for operation `registryControllerGetOne()` */
  static readonly RegistryControllerGetOnePath = '/registry/{id}';

  /**
   * Restituisce una azienda.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registryControllerGetOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  registryControllerGetOne$Response(params: RegistryControllerGetOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>> {
    return registryControllerGetOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce una azienda.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registryControllerGetOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  registryControllerGetOne(params: RegistryControllerGetOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryItem;
}> {
    return this.registryControllerGetOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>): BaseResponse & {
'data'?: RegistryItem;
} => r.body)
    );
  }

  /** Path part for operation `registryControllerDelete()` */
  static readonly RegistryControllerDeletePath = '/registry/{id}';

  /**
   * Elimina una azienda e la sposta nel cestino.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registryControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  registryControllerDelete$Response(params: RegistryControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>> {
    return registryControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina una azienda e la sposta nel cestino.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registryControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  registryControllerDelete(params: RegistryControllerDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryItem;
}> {
    return this.registryControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>): BaseResponse & {
'data'?: RegistryItem;
} => r.body)
    );
  }

  /** Path part for operation `registryControllerUpdate()` */
  static readonly RegistryControllerUpdatePath = '/registry/{id}';

  /**
   * Modifica una azienda.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registryControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registryControllerUpdate$Response(params: RegistryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>> {
    return registryControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica una azienda.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registryControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registryControllerUpdate(params: RegistryControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryItem;
}> {
    return this.registryControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>): BaseResponse & {
'data'?: RegistryItem;
} => r.body)
    );
  }

  /** Path part for operation `registryControllerAddUsers()` */
  static readonly RegistryControllerAddUsersPath = '/registry/{id}/users';

  /**
   * Modifica gli utenti di una azienda.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registryControllerAddUsers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registryControllerAddUsers$Response(params: RegistryControllerAddUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>> {
    return registryControllerAddUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica gli utenti di una azienda.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registryControllerAddUsers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registryControllerAddUsers(params: RegistryControllerAddUsers$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryItem;
}> {
    return this.registryControllerAddUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>): BaseResponse & {
'data'?: RegistryItem;
} => r.body)
    );
  }

  /** Path part for operation `registryControllerUpdateRegistryEndCustomer()` */
  static readonly RegistryControllerUpdateRegistryEndCustomerPath = '/registry/{id}/registry_end_customer';

  /**
   * Modifica un'azienda cliente finale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registryControllerUpdateRegistryEndCustomer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registryControllerUpdateRegistryEndCustomer$Response(params: RegistryControllerUpdateRegistryEndCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>> {
    return registryControllerUpdateRegistryEndCustomer(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica un'azienda cliente finale.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registryControllerUpdateRegistryEndCustomer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registryControllerUpdateRegistryEndCustomer(params: RegistryControllerUpdateRegistryEndCustomer$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryItem;
}> {
    return this.registryControllerUpdateRegistryEndCustomer$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>): BaseResponse & {
'data'?: RegistryItem;
} => r.body)
    );
  }

  /** Path part for operation `registryControllerAddLogo()` */
  static readonly RegistryControllerAddLogoPath = '/registry/{id}/logo';

  /**
   * Logo della registry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registryControllerAddLogo()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  registryControllerAddLogo$Response(params: RegistryControllerAddLogo$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>> {
    return registryControllerAddLogo(this.http, this.rootUrl, params, context);
  }

  /**
   * Logo della registry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registryControllerAddLogo$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  registryControllerAddLogo(params: RegistryControllerAddLogo$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryItem;
}> {
    return this.registryControllerAddLogo$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>): BaseResponse & {
'data'?: RegistryItem;
} => r.body)
    );
  }

  /** Path part for operation `registryControllerRemoveLogo()` */
  static readonly RegistryControllerRemoveLogoPath = '/registry/{id}/logo';

  /**
   * Rimuovi logo della registry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registryControllerRemoveLogo()` instead.
   *
   * This method doesn't expect any request body.
   */
  registryControllerRemoveLogo$Response(params: RegistryControllerRemoveLogo$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>> {
    return registryControllerRemoveLogo(this.http, this.rootUrl, params, context);
  }

  /**
   * Rimuovi logo della registry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registryControllerRemoveLogo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  registryControllerRemoveLogo(params: RegistryControllerRemoveLogo$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryItem;
}> {
    return this.registryControllerRemoveLogo$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>): BaseResponse & {
'data'?: RegistryItem;
} => r.body)
    );
  }

  /** Path part for operation `registryControllerGetAllDeleted()` */
  static readonly RegistryControllerGetAllDeletedPath = '/registry/deleted';

  /**
   * Restituisce l'elenco delle aziende eliminate.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registryControllerGetAllDeleted()` instead.
   *
   * This method doesn't expect any request body.
   */
  registryControllerGetAllDeleted$Response(params: RegistryControllerGetAllDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryResponse;
}>> {
    return registryControllerGetAllDeleted(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco delle aziende eliminate.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registryControllerGetAllDeleted$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  registryControllerGetAllDeleted(params: RegistryControllerGetAllDeleted$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryResponse;
}> {
    return this.registryControllerGetAllDeleted$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryResponse;
}>): BaseResponse & {
'data'?: RegistryResponse;
} => r.body)
    );
  }

  /** Path part for operation `registryControllerGetTypes()` */
  static readonly RegistryControllerGetTypesPath = '/registry/types';

  /**
   * Restituisce i tipi di aziende.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registryControllerGetTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  registryControllerGetTypes$Response(params?: RegistryControllerGetTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryTypeResponse;
}>> {
    return registryControllerGetTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce i tipi di aziende.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registryControllerGetTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  registryControllerGetTypes(params?: RegistryControllerGetTypes$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryTypeResponse;
}> {
    return this.registryControllerGetTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryTypeResponse;
}>): BaseResponse & {
'data'?: RegistryTypeResponse;
} => r.body)
    );
  }

  /** Path part for operation `registryControllerAssignRegistry()` */
  static readonly RegistryControllerAssignRegistryPath = '/registry/registry';

  /**
   * Assegna utenti alle aziende.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registryControllerAssignRegistry()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registryControllerAssignRegistry$Response(params: RegistryControllerAssignRegistry$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse>> {
    return registryControllerAssignRegistry(this.http, this.rootUrl, params, context);
  }

  /**
   * Assegna utenti alle aziende.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registryControllerAssignRegistry$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registryControllerAssignRegistry(params: RegistryControllerAssignRegistry$Params, context?: HttpContext): Observable<BaseResponse> {
    return this.registryControllerAssignRegistry$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse>): BaseResponse => r.body)
    );
  }

  /** Path part for operation `registryControllerDissociaUser()` */
  static readonly RegistryControllerDissociaUserPath = '/registry/{idRegistry}/user/{idUser}';

  /**
   * Dissocia un utente da una azienda.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registryControllerDissociaUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  registryControllerDissociaUser$Response(params: RegistryControllerDissociaUser$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>> {
    return registryControllerDissociaUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Dissocia un utente da una azienda.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registryControllerDissociaUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  registryControllerDissociaUser(params: RegistryControllerDissociaUser$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryItem;
}> {
    return this.registryControllerDissociaUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>): BaseResponse & {
'data'?: RegistryItem;
} => r.body)
    );
  }

  /** Path part for operation `registryControllerForceDelete()` */
  static readonly RegistryControllerForceDeletePath = '/registry/{id}/delete';

  /**
   * Elimina una azienda permanentemente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registryControllerForceDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  registryControllerForceDelete$Response(params: RegistryControllerForceDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>> {
    return registryControllerForceDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina una azienda permanentemente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registryControllerForceDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  registryControllerForceDelete(params: RegistryControllerForceDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryItem;
}> {
    return this.registryControllerForceDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>): BaseResponse & {
'data'?: RegistryItem;
} => r.body)
    );
  }

  /** Path part for operation `registryControllerRestore()` */
  static readonly RegistryControllerRestorePath = '/registry/{id}/restore';

  /**
   * Ripristina una azienda dal cestino.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registryControllerRestore()` instead.
   *
   * This method doesn't expect any request body.
   */
  registryControllerRestore$Response(params: RegistryControllerRestore$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>> {
    return registryControllerRestore(this.http, this.rootUrl, params, context);
  }

  /**
   * Ripristina una azienda dal cestino.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registryControllerRestore$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  registryControllerRestore(params: RegistryControllerRestore$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryItem;
}> {
    return this.registryControllerRestore$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>): BaseResponse & {
'data'?: RegistryItem;
} => r.body)
    );
  }

}
